import { render, staticRenderFns } from "./boton-cerrar-modal.vue?vue&type=template&id=e1397ed2&scoped=true&"
import script from "./boton-cerrar-modal.vue?vue&type=script&lang=js&"
export * from "./boton-cerrar-modal.vue?vue&type=script&lang=js&"
import style0 from "./boton-cerrar-modal.vue?vue&type=style&index=0&id=e1397ed2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e1397ed2",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!F:/Backup_Juan/ecopetrol/Cursos 2019/hidrocarburos/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCardTitle } from 'vuetify/lib'
import { VSpacer } from 'vuetify/lib'
installComponents(component, {VCardTitle,VSpacer})
